import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LEAD_STAGE_COLORS, LeadStage } from '../../../core/models/lead.model';
import { ChipComponent } from '../chip/chip.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

/** Renders a lead's stage as a coloured chip — same color-per-stage everywhere it's shown. */
@Component({
  selector: 'app-lead-stage-chip',
  standalone: true,
  imports: [ChipComponent, TranslatePipe],
  templateUrl: './lead-stage-chip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './lead-stage-chip.component.css',
})
export class LeadStageChipComponent {
  stage = input.required<LeadStage>();

  color = computed(() => LEAD_STAGE_COLORS[this.stage()]);
  labelKey = computed(() => `leads.stage.${this.stage()}`);
}
